import _objectWithoutProperties from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _defineProperty from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _asyncToGenerator from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
var _excluded = ["target", "manager", "queryRunner"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
import { EntityNotFoundError } from "../error/EntityNotFoundError";
import { QueryRunnerProviderAlreadyReleasedError } from "../error/QueryRunnerProviderAlreadyReleasedError";
import { NoNeedToReleaseEntityManagerError } from "../error/NoNeedToReleaseEntityManagerError";
import { MongoRepository } from "../repository/MongoRepository";
import { TreeRepository } from "../repository/TreeRepository";
import { Repository } from "../repository/Repository";
import { FindOptionsUtils } from "../find-options/FindOptionsUtils";
import { PlainObjectToNewEntityTransformer } from "../query-builder/transformer/PlainObjectToNewEntityTransformer";
import { PlainObjectToDatabaseEntityTransformer } from "../query-builder/transformer/PlainObjectToDatabaseEntityTransformer";
import { CustomRepositoryCannotInheritRepositoryError, CustomRepositoryNotFoundError, TreeRepositoryNotSupportedError, TypeORMError } from "../error";
import { AbstractRepository } from "../repository/AbstractRepository";
import { EntityPersistExecutor } from "../persistence/EntityPersistExecutor";
import { ObjectUtils } from "../util/ObjectUtils";
import { getMetadataArgsStorage } from "../globals";
import { InstanceChecker } from "../util/InstanceChecker";
/**
 * Entity manager supposed to work with any entity, automatically find its repository and call its methods,
 * whatever entity type are you passing.
 */
export var EntityManager = /*#__PURE__*/function () {
  // -------------------------------------------------------------------------
  // Constructor
  // -------------------------------------------------------------------------
  function EntityManager(connection, queryRunner) {
    _classCallCheck(this, EntityManager);
    this["@instanceof"] = Symbol.for("EntityManager");
    // -------------------------------------------------------------------------
    // Protected Properties
    // -------------------------------------------------------------------------
    /**
     * Once created and then reused by repositories.
     */
    this.repositories = [];
    /**
     * Once created and then reused by repositories.
     */
    this.treeRepositories = [];
    /**
     * Plain to object transformer used in create and merge operations.
     */
    this.plainObjectToEntityTransformer = new PlainObjectToNewEntityTransformer();
    this.connection = connection;
    if (queryRunner) {
      this.queryRunner = queryRunner;
      // dynamic: this.queryRunner = manager;
      ObjectUtils.assign(this.queryRunner, {
        manager: this
      });
    }
  }
  /**
   * Wraps given function execution (and all operations made there) in a transaction.
   * All database operations must be executed using provided entity manager.
   */
  _createClass(EntityManager, [{
    key: "transaction",
    value: function () {
      var _transaction = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(isolationOrRunInTransaction, runInTransactionParam) {
        var isolation, runInTransaction, queryRunner, result;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              isolation = typeof isolationOrRunInTransaction === "string" ? isolationOrRunInTransaction : undefined;
              runInTransaction = typeof isolationOrRunInTransaction === "function" ? isolationOrRunInTransaction : runInTransactionParam;
              if (runInTransaction) {
                _context.next = 4;
                break;
              }
              throw new TypeORMError("Transaction method requires callback in second parameter if isolation level is supplied.");
            case 4:
              if (!(this.queryRunner && this.queryRunner.isReleased)) {
                _context.next = 6;
                break;
              }
              throw new QueryRunnerProviderAlreadyReleasedError();
            case 6:
              // if query runner is already defined in this class, it means this entity manager was already created for a single connection
              // if its not defined we create a new query runner - single connection where we'll execute all our operations
              queryRunner = this.queryRunner || this.connection.createQueryRunner();
              _context.prev = 7;
              _context.next = 10;
              return queryRunner.startTransaction(isolation);
            case 10:
              _context.next = 12;
              return runInTransaction(queryRunner.manager);
            case 12:
              result = _context.sent;
              _context.next = 15;
              return queryRunner.commitTransaction();
            case 15:
              return _context.abrupt("return", result);
            case 18:
              _context.prev = 18;
              _context.t0 = _context["catch"](7);
              _context.prev = 20;
              _context.next = 23;
              return queryRunner.rollbackTransaction();
            case 23:
              _context.next = 27;
              break;
            case 25:
              _context.prev = 25;
              _context.t1 = _context["catch"](20);
            case 27:
              throw _context.t0;
            case 28:
              _context.prev = 28;
              if (this.queryRunner) {
                _context.next = 32;
                break;
              }
              _context.next = 32;
              return queryRunner.release();
            case 32:
              return _context.finish(28);
            case 33:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[7, 18, 28, 33], [20, 25]]);
      }));
      function transaction(_x, _x2) {
        return _transaction.apply(this, arguments);
      }
      return transaction;
    }()
    /**
     * Executes raw SQL query and returns raw database results.
     */
  }, {
    key: "query",
    value: function () {
      var _query2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(_query, parameters) {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", this.connection.query(_query, parameters, this.queryRunner));
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function query(_x3, _x4) {
        return _query2.apply(this, arguments);
      }
      return query;
    }()
    /**
     * Creates a new query builder that can be used to build a SQL query.
     */
  }, {
    key: "createQueryBuilder",
    value: function createQueryBuilder(entityClass, alias, queryRunner) {
      if (alias) {
        return this.connection.createQueryBuilder(entityClass, alias, queryRunner || this.queryRunner);
      } else {
        return this.connection.createQueryBuilder(entityClass || queryRunner || this.queryRunner);
      }
    }
    /**
     * Checks if entity has an id by its Function type or schema name.
     */
  }, {
    key: "hasId",
    value: function hasId(targetOrEntity, maybeEntity) {
      var target = arguments.length === 2 ? targetOrEntity : targetOrEntity.constructor;
      var entity = arguments.length === 2 ? maybeEntity : targetOrEntity;
      var metadata = this.connection.getMetadata(target);
      return metadata.hasId(entity);
    }
    /**
     * Gets entity mixed id.
     */
  }, {
    key: "getId",
    value: function getId(targetOrEntity, maybeEntity) {
      var target = arguments.length === 2 ? targetOrEntity : targetOrEntity.constructor;
      var entity = arguments.length === 2 ? maybeEntity : targetOrEntity;
      var metadata = this.connection.getMetadata(target);
      return metadata.getEntityIdMixedMap(entity);
    }
    /**
     * Creates a new entity instance or instances.
     * Can copy properties from the given object into new entities.
     */
  }, {
    key: "create",
    value: function create(entityClass, plainObjectOrObjects) {
      var _this = this;
      var metadata = this.connection.getMetadata(entityClass);
      if (!plainObjectOrObjects) return metadata.create(this.queryRunner);
      if (Array.isArray(plainObjectOrObjects)) return plainObjectOrObjects.map(function (plainEntityLike) {
        return _this.create(entityClass, plainEntityLike);
      });
      var mergeIntoEntity = metadata.create(this.queryRunner);
      this.plainObjectToEntityTransformer.transform(mergeIntoEntity, plainObjectOrObjects, metadata, true);
      return mergeIntoEntity;
    }
    /**
     * Merges two entities into one new entity.
     */
  }, {
    key: "merge",
    value: function merge(entityClass, mergeIntoEntity) {
      var _this2 = this;
      // todo: throw exception if entity manager is released
      var metadata = this.connection.getMetadata(entityClass);
      for (var _len = arguments.length, entityLikes = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
        entityLikes[_key - 2] = arguments[_key];
      }
      entityLikes.forEach(function (object) {
        return _this2.plainObjectToEntityTransformer.transform(mergeIntoEntity, object, metadata);
      });
      return mergeIntoEntity;
    }
    /**
     * Creates a new entity from the given plain javascript object. If entity already exist in the database, then
     * it loads it (and everything related to it), replaces all values with the new ones from the given object
     * and returns this new entity. This new entity is actually a loaded from the db entity with all properties
     * replaced from the new object.
     */
  }, {
    key: "preload",
    value: function () {
      var _preload = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(entityClass, entityLike) {
        var metadata, plainObjectToDatabaseEntityTransformer, transformedEntity;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              metadata = this.connection.getMetadata(entityClass);
              plainObjectToDatabaseEntityTransformer = new PlainObjectToDatabaseEntityTransformer(this.connection.manager);
              _context3.next = 4;
              return plainObjectToDatabaseEntityTransformer.transform(entityLike, metadata);
            case 4:
              transformedEntity = _context3.sent;
              if (!transformedEntity) {
                _context3.next = 7;
                break;
              }
              return _context3.abrupt("return", this.merge(entityClass, transformedEntity, entityLike));
            case 7:
              return _context3.abrupt("return", undefined);
            case 8:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function preload(_x5, _x6) {
        return _preload.apply(this, arguments);
      }
      return preload;
    }()
    /**
     * Saves a given entity in the database.
     */
  }, {
    key: "save",
    value: function save(targetOrEntity, maybeEntityOrOptions, maybeOptions) {
      // normalize mixed parameters
      var target = arguments.length > 1 && (typeof targetOrEntity === "function" || InstanceChecker.isEntitySchema(targetOrEntity) || typeof targetOrEntity === "string") ? targetOrEntity : undefined;
      var entity = target ? maybeEntityOrOptions : targetOrEntity;
      var options = target ? maybeOptions : maybeEntityOrOptions;
      if (InstanceChecker.isEntitySchema(target)) target = target.options.name;
      // if user passed empty array of entities then we don't need to do anything
      if (Array.isArray(entity) && entity.length === 0) return Promise.resolve(entity);
      // execute save operation
      return new EntityPersistExecutor(this.connection, this.queryRunner, "save", target, entity, options).execute().then(function () {
        return entity;
      });
    }
    /**
     * Removes a given entity from the database.
     */
  }, {
    key: "remove",
    value: function remove(targetOrEntity, maybeEntityOrOptions, maybeOptions) {
      // normalize mixed parameters
      var target = arguments.length > 1 && (typeof targetOrEntity === "function" || InstanceChecker.isEntitySchema(targetOrEntity) || typeof targetOrEntity === "string") ? targetOrEntity : undefined;
      var entity = target ? maybeEntityOrOptions : targetOrEntity;
      var options = target ? maybeOptions : maybeEntityOrOptions;
      // if user passed empty array of entities then we don't need to do anything
      if (Array.isArray(entity) && entity.length === 0) return Promise.resolve(entity);
      // execute save operation
      return new EntityPersistExecutor(this.connection, this.queryRunner, "remove", target, entity, options).execute().then(function () {
        return entity;
      });
    }
    /**
     * Records the delete date of one or many given entities.
     */
  }, {
    key: "softRemove",
    value: function softRemove(targetOrEntity, maybeEntityOrOptions, maybeOptions) {
      // normalize mixed parameters
      var target = arguments.length > 1 && (typeof targetOrEntity === "function" || InstanceChecker.isEntitySchema(targetOrEntity) || typeof targetOrEntity === "string") ? targetOrEntity : undefined;
      var entity = target ? maybeEntityOrOptions : targetOrEntity;
      var options = target ? maybeOptions : maybeEntityOrOptions;
      if (InstanceChecker.isEntitySchema(target)) target = target.options.name;
      // if user passed empty array of entities then we don't need to do anything
      if (Array.isArray(entity) && entity.length === 0) return Promise.resolve(entity);
      // execute soft-remove operation
      return new EntityPersistExecutor(this.connection, this.queryRunner, "soft-remove", target, entity, options).execute().then(function () {
        return entity;
      });
    }
    /**
     * Recovers one or many given entities.
     */
  }, {
    key: "recover",
    value: function recover(targetOrEntity, maybeEntityOrOptions, maybeOptions) {
      // normalize mixed parameters
      var target = arguments.length > 1 && (typeof targetOrEntity === "function" || InstanceChecker.isEntitySchema(targetOrEntity) || typeof targetOrEntity === "string") ? targetOrEntity : undefined;
      var entity = target ? maybeEntityOrOptions : targetOrEntity;
      var options = target ? maybeOptions : maybeEntityOrOptions;
      if (InstanceChecker.isEntitySchema(target)) target = target.options.name;
      // if user passed empty array of entities then we don't need to do anything
      if (Array.isArray(entity) && entity.length === 0) return Promise.resolve(entity);
      // execute recover operation
      return new EntityPersistExecutor(this.connection, this.queryRunner, "recover", target, entity, options).execute().then(function () {
        return entity;
      });
    }
    /**
     * Inserts a given entity into the database.
     * Unlike save method executes a primitive operation without cascades, relations and other operations included.
     * Executes fast and efficient INSERT query.
     * Does not check if entity exist in the database, so query will fail if duplicate entity is being inserted.
     * You can execute bulk inserts using this method.
     */
  }, {
    key: "insert",
    value: function () {
      var _insert = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(target, entity) {
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              return _context4.abrupt("return", this.createQueryBuilder().insert().into(target).values(entity).execute());
            case 1:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function insert(_x7, _x8) {
        return _insert.apply(this, arguments);
      }
      return insert;
    }()
  }, {
    key: "upsert",
    value: function () {
      var _upsert = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(target, entityOrEntities, conflictPathsOrOptions) {
        var metadata, options, entities, conflictColumns, overwriteColumns;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              metadata = this.connection.getMetadata(target);
              if (Array.isArray(conflictPathsOrOptions)) {
                options = {
                  conflictPaths: conflictPathsOrOptions
                };
              } else {
                options = conflictPathsOrOptions;
              }
              if (!Array.isArray(entityOrEntities)) {
                entities = [entityOrEntities];
              } else {
                entities = entityOrEntities;
              }
              conflictColumns = metadata.mapPropertyPathsToColumns(Array.isArray(options.conflictPaths) ? options.conflictPaths : Object.keys(options.conflictPaths));
              overwriteColumns = metadata.columns.filter(function (col) {
                return !conflictColumns.includes(col) && entities.some(function (entity) {
                  return typeof col.getEntityValue(entity) !== "undefined";
                });
              });
              return _context5.abrupt("return", this.createQueryBuilder().insert().into(target).values(entities).orUpdate([].concat(_toConsumableArray(conflictColumns), _toConsumableArray(overwriteColumns)).map(function (col) {
                return col.databaseName;
              }), conflictColumns.map(function (col) {
                return col.databaseName;
              }), {
                skipUpdateIfNoValuesChanged: options.skipUpdateIfNoValuesChanged,
                indexPredicate: options.indexPredicate
              }).execute());
            case 6:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function upsert(_x9, _x10, _x11) {
        return _upsert.apply(this, arguments);
      }
      return upsert;
    }()
    /**
     * Updates entity partially. Entity can be found by a given condition(s).
     * Unlike save method executes a primitive operation without cascades, relations and other operations included.
     * Executes fast and efficient UPDATE query.
     * Does not check if entity exist in the database.
     * Condition(s) cannot be empty.
     */
  }, {
    key: "update",
    value: function update(target, criteria, partialEntity) {
      // if user passed empty criteria or empty list of criterias, then throw an error
      if (criteria === undefined || criteria === null || criteria === "" || Array.isArray(criteria) && criteria.length === 0) {
        return Promise.reject(new TypeORMError("Empty criteria(s) are not allowed for the update method."));
      }
      if (typeof criteria === "string" || typeof criteria === "number" || criteria instanceof Date || Array.isArray(criteria)) {
        return this.createQueryBuilder().update(target).set(partialEntity).whereInIds(criteria).execute();
      } else {
        return this.createQueryBuilder().update(target).set(partialEntity).where(criteria).execute();
      }
    }
    /**
     * Deletes entities by a given condition(s).
     * Unlike save method executes a primitive operation without cascades, relations and other operations included.
     * Executes fast and efficient DELETE query.
     * Does not check if entity exist in the database.
     * Condition(s) cannot be empty.
     */
  }, {
    key: "delete",
    value: function _delete(targetOrEntity, criteria) {
      // if user passed empty criteria or empty list of criterias, then throw an error
      if (criteria === undefined || criteria === null || criteria === "" || Array.isArray(criteria) && criteria.length === 0) {
        return Promise.reject(new TypeORMError("Empty criteria(s) are not allowed for the delete method."));
      }
      if (typeof criteria === "string" || typeof criteria === "number" || criteria instanceof Date || Array.isArray(criteria)) {
        return this.createQueryBuilder().delete().from(targetOrEntity).whereInIds(criteria).execute();
      } else {
        return this.createQueryBuilder().delete().from(targetOrEntity).where(criteria).execute();
      }
    }
    /**
     * Records the delete date of entities by a given condition(s).
     * Unlike save method executes a primitive operation without cascades, relations and other operations included.
     * Executes fast and efficient DELETE query.
     * Does not check if entity exist in the database.
     * Condition(s) cannot be empty.
     */
  }, {
    key: "softDelete",
    value: function softDelete(targetOrEntity, criteria) {
      // if user passed empty criteria or empty list of criterias, then throw an error
      if (criteria === undefined || criteria === null || criteria === "" || Array.isArray(criteria) && criteria.length === 0) {
        return Promise.reject(new TypeORMError("Empty criteria(s) are not allowed for the delete method."));
      }
      if (typeof criteria === "string" || typeof criteria === "number" || criteria instanceof Date || Array.isArray(criteria)) {
        return this.createQueryBuilder().softDelete().from(targetOrEntity).whereInIds(criteria).execute();
      } else {
        return this.createQueryBuilder().softDelete().from(targetOrEntity).where(criteria).execute();
      }
    }
    /**
     * Restores entities by a given condition(s).
     * Unlike save method executes a primitive operation without cascades, relations and other operations included.
     * Executes fast and efficient DELETE query.
     * Does not check if entity exist in the database.
     * Condition(s) cannot be empty.
     */
  }, {
    key: "restore",
    value: function restore(targetOrEntity, criteria) {
      // if user passed empty criteria or empty list of criterias, then throw an error
      if (criteria === undefined || criteria === null || criteria === "" || Array.isArray(criteria) && criteria.length === 0) {
        return Promise.reject(new TypeORMError("Empty criteria(s) are not allowed for the delete method."));
      }
      if (typeof criteria === "string" || typeof criteria === "number" || criteria instanceof Date || Array.isArray(criteria)) {
        return this.createQueryBuilder().restore().from(targetOrEntity).whereInIds(criteria).execute();
      } else {
        return this.createQueryBuilder().restore().from(targetOrEntity).where(criteria).execute();
      }
    }
    /**
     * Checks whether any entity exists with the given condition
     */
  }, {
    key: "exists",
    value: function exists(entityClass, options) {
      var metadata = this.connection.getMetadata(entityClass);
      return this.createQueryBuilder(entityClass, FindOptionsUtils.extractFindManyOptionsAlias(options) || metadata.name).setFindOptions(options || {}).getExists();
    }
    /**
     * Counts entities that match given options.
     * Useful for pagination.
     */
  }, {
    key: "count",
    value: function count(entityClass, options) {
      var metadata = this.connection.getMetadata(entityClass);
      return this.createQueryBuilder(entityClass, FindOptionsUtils.extractFindManyOptionsAlias(options) || metadata.name).setFindOptions(options || {}).getCount();
    }
    /**
     * Counts entities that match given conditions.
     * Useful for pagination.
     */
  }, {
    key: "countBy",
    value: function countBy(entityClass, where) {
      var metadata = this.connection.getMetadata(entityClass);
      return this.createQueryBuilder(entityClass, metadata.name).setFindOptions({
        where: where
      }).getCount();
    }
    /**
     * Finds entities that match given find options.
     */
  }, {
    key: "find",
    value: function () {
      var _find = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(entityClass, options) {
        var metadata;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              metadata = this.connection.getMetadata(entityClass);
              return _context6.abrupt("return", this.createQueryBuilder(entityClass, FindOptionsUtils.extractFindManyOptionsAlias(options) || metadata.name).setFindOptions(options || {}).getMany());
            case 2:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function find(_x12, _x13) {
        return _find.apply(this, arguments);
      }
      return find;
    }()
    /**
     * Finds entities that match given find options.
     */
  }, {
    key: "findBy",
    value: function () {
      var _findBy = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(entityClass, where) {
        var metadata;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              metadata = this.connection.getMetadata(entityClass);
              return _context7.abrupt("return", this.createQueryBuilder(entityClass, metadata.name).setFindOptions({
                where: where
              }).getMany());
            case 2:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function findBy(_x14, _x15) {
        return _findBy.apply(this, arguments);
      }
      return findBy;
    }()
    /**
     * Finds entities that match given find options.
     * Also counts all entities that match given conditions,
     * but ignores pagination settings (from and take options).
     */
  }, {
    key: "findAndCount",
    value: function findAndCount(entityClass, options) {
      var metadata = this.connection.getMetadata(entityClass);
      return this.createQueryBuilder(entityClass, FindOptionsUtils.extractFindManyOptionsAlias(options) || metadata.name).setFindOptions(options || {}).getManyAndCount();
    }
    /**
     * Finds entities that match given WHERE conditions.
     * Also counts all entities that match given conditions,
     * but ignores pagination settings (from and take options).
     */
  }, {
    key: "findAndCountBy",
    value: function findAndCountBy(entityClass, where) {
      var metadata = this.connection.getMetadata(entityClass);
      return this.createQueryBuilder(entityClass, metadata.name).setFindOptions({
        where: where
      }).getManyAndCount();
    }
    /**
     * Finds entities with ids.
     * Optionally find options or conditions can be applied.
     *
     * @deprecated use `findBy` method instead in conjunction with `In` operator, for example:
     *
     * .findBy({
     *     id: In([1, 2, 3])
     * })
     */
  }, {
    key: "findByIds",
    value: function () {
      var _findByIds = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(entityClass, ids) {
        var metadata;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              if (ids.length) {
                _context8.next = 2;
                break;
              }
              return _context8.abrupt("return", Promise.resolve([]));
            case 2:
              metadata = this.connection.getMetadata(entityClass);
              return _context8.abrupt("return", this.createQueryBuilder(entityClass, metadata.name).andWhereInIds(ids).getMany());
            case 4:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this);
      }));
      function findByIds(_x16, _x17) {
        return _findByIds.apply(this, arguments);
      }
      return findByIds;
    }()
    /**
     * Finds first entity by a given find options.
     * If entity was not found in the database - returns null.
     */
  }, {
    key: "findOne",
    value: function () {
      var _findOne = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9(entityClass, options) {
        var metadata, alias;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              metadata = this.connection.getMetadata(entityClass); // prepare alias for built query
              alias = metadata.name;
              if (options && options.join) {
                alias = options.join.alias;
              }
              if (options.where) {
                _context9.next = 5;
                break;
              }
              throw new Error("You must provide selection conditions in order to find a single row.");
            case 5:
              return _context9.abrupt("return", this.createQueryBuilder(entityClass, alias).setFindOptions(_objectSpread(_objectSpread({}, options), {}, {
                take: 1
              })).getOne());
            case 6:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this);
      }));
      function findOne(_x18, _x19) {
        return _findOne.apply(this, arguments);
      }
      return findOne;
    }()
    /**
     * Finds first entity that matches given where condition.
     * If entity was not found in the database - returns null.
     */
  }, {
    key: "findOneBy",
    value: function () {
      var _findOneBy = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10(entityClass, where) {
        var metadata;
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              metadata = this.connection.getMetadata(entityClass); // create query builder and apply find options
              return _context10.abrupt("return", this.createQueryBuilder(entityClass, metadata.name).setFindOptions({
                where: where,
                take: 1
              }).getOne());
            case 2:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this);
      }));
      function findOneBy(_x20, _x21) {
        return _findOneBy.apply(this, arguments);
      }
      return findOneBy;
    }()
    /**
     * Finds first entity that matches given id.
     * If entity was not found in the database - returns null.
     *
     * @deprecated use `findOneBy` method instead in conjunction with `In` operator, for example:
     *
     * .findOneBy({
     *     id: 1 // where "id" is your primary column name
     * })
     */
  }, {
    key: "findOneById",
    value: function () {
      var _findOneById = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11(entityClass, id) {
        var metadata;
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              metadata = this.connection.getMetadata(entityClass); // create query builder and apply find options
              return _context11.abrupt("return", this.createQueryBuilder(entityClass, metadata.name).setFindOptions({
                take: 1
              }).whereInIds(metadata.ensureEntityIdMap(id)).getOne());
            case 2:
            case "end":
              return _context11.stop();
          }
        }, _callee11, this);
      }));
      function findOneById(_x22, _x23) {
        return _findOneById.apply(this, arguments);
      }
      return findOneById;
    }()
    /**
     * Finds first entity by a given find options.
     * If entity was not found in the database - rejects with error.
     */
  }, {
    key: "findOneOrFail",
    value: function () {
      var _findOneOrFail = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee12(entityClass, options) {
        return _regeneratorRuntime().wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              return _context12.abrupt("return", this.findOne(entityClass, options).then(function (value) {
                if (value === null) {
                  return Promise.reject(new EntityNotFoundError(entityClass, options));
                }
                return Promise.resolve(value);
              }));
            case 1:
            case "end":
              return _context12.stop();
          }
        }, _callee12, this);
      }));
      function findOneOrFail(_x24, _x25) {
        return _findOneOrFail.apply(this, arguments);
      }
      return findOneOrFail;
    }()
    /**
     * Finds first entity that matches given where condition.
     * If entity was not found in the database - rejects with error.
     */
  }, {
    key: "findOneByOrFail",
    value: function () {
      var _findOneByOrFail = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee13(entityClass, where) {
        return _regeneratorRuntime().wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              return _context13.abrupt("return", this.findOneBy(entityClass, where).then(function (value) {
                if (value === null) {
                  return Promise.reject(new EntityNotFoundError(entityClass, where));
                }
                return Promise.resolve(value);
              }));
            case 1:
            case "end":
              return _context13.stop();
          }
        }, _callee13, this);
      }));
      function findOneByOrFail(_x26, _x27) {
        return _findOneByOrFail.apply(this, arguments);
      }
      return findOneByOrFail;
    }()
    /**
     * Clears all the data from the given table (truncates/drops it).
     *
     * Note: this method uses TRUNCATE and may not work as you expect in transactions on some platforms.
     * @see https://stackoverflow.com/a/5972738/925151
     */
  }, {
    key: "clear",
    value: function () {
      var _clear = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee14(entityClass) {
        var metadata, queryRunner;
        return _regeneratorRuntime().wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              metadata = this.connection.getMetadata(entityClass);
              queryRunner = this.queryRunner || this.connection.createQueryRunner();
              _context14.prev = 2;
              _context14.next = 5;
              return queryRunner.clearTable(metadata.tablePath);
            case 5:
              return _context14.abrupt("return", _context14.sent);
            case 6:
              _context14.prev = 6;
              if (this.queryRunner) {
                _context14.next = 10;
                break;
              }
              _context14.next = 10;
              return queryRunner.release();
            case 10:
              return _context14.finish(6);
            case 11:
            case "end":
              return _context14.stop();
          }
        }, _callee14, this, [[2,, 6, 11]]);
      }));
      function clear(_x28) {
        return _clear.apply(this, arguments);
      }
      return clear;
    }()
    /**
     * Increments some column by provided value of the entities matched given conditions.
     */
  }, {
    key: "increment",
    value: function () {
      var _increment = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee15(entityClass, conditions, propertyPath, value) {
        var _this3 = this;
        var metadata, column, values;
        return _regeneratorRuntime().wrap(function _callee15$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              metadata = this.connection.getMetadata(entityClass);
              column = metadata.findColumnWithPropertyPath(propertyPath);
              if (column) {
                _context15.next = 4;
                break;
              }
              throw new TypeORMError("Column ".concat(propertyPath, " was not found in ").concat(metadata.targetName, " entity."));
            case 4:
              if (!isNaN(Number(value))) {
                _context15.next = 6;
                break;
              }
              throw new TypeORMError("Value \"".concat(value, "\" is not a number."));
            case 6:
              // convert possible embeded path "social.likes" into object { social: { like: () => value } }
              values = propertyPath.split(".").reduceRight(function (value, key) {
                return _defineProperty({}, key, value);
              }, function () {
                return _this3.connection.driver.escape(column.databaseName) + " + " + value;
              });
              return _context15.abrupt("return", this.createQueryBuilder(entityClass, "entity").update(entityClass).set(values).where(conditions).execute());
            case 8:
            case "end":
              return _context15.stop();
          }
        }, _callee15, this);
      }));
      function increment(_x29, _x30, _x31, _x32) {
        return _increment.apply(this, arguments);
      }
      return increment;
    }()
    /**
     * Decrements some column by provided value of the entities matched given conditions.
     */
  }, {
    key: "decrement",
    value: function () {
      var _decrement = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee16(entityClass, conditions, propertyPath, value) {
        var _this4 = this;
        var metadata, column, values;
        return _regeneratorRuntime().wrap(function _callee16$(_context16) {
          while (1) switch (_context16.prev = _context16.next) {
            case 0:
              metadata = this.connection.getMetadata(entityClass);
              column = metadata.findColumnWithPropertyPath(propertyPath);
              if (column) {
                _context16.next = 4;
                break;
              }
              throw new TypeORMError("Column ".concat(propertyPath, " was not found in ").concat(metadata.targetName, " entity."));
            case 4:
              if (!isNaN(Number(value))) {
                _context16.next = 6;
                break;
              }
              throw new TypeORMError("Value \"".concat(value, "\" is not a number."));
            case 6:
              // convert possible embeded path "social.likes" into object { social: { like: () => value } }
              values = propertyPath.split(".").reduceRight(function (value, key) {
                return _defineProperty({}, key, value);
              }, function () {
                return _this4.connection.driver.escape(column.databaseName) + " - " + value;
              });
              return _context16.abrupt("return", this.createQueryBuilder(entityClass, "entity").update(entityClass).set(values).where(conditions).execute());
            case 8:
            case "end":
              return _context16.stop();
          }
        }, _callee16, this);
      }));
      function decrement(_x33, _x34, _x35, _x36) {
        return _decrement.apply(this, arguments);
      }
      return decrement;
    }()
    /**
     * Gets repository for the given entity class or name.
     * If single database connection mode is used, then repository is obtained from the
     * repository aggregator, where each repository is individually created for this entity manager.
     * When single database connection is not used, repository is being obtained from the connection.
     */
  }, {
    key: "getRepository",
    value: function getRepository(target) {
      // find already created repository instance and return it if found
      var repository = this.repositories.find(function (repository) {
        return repository.target === target;
      });
      if (repository) return repository;
      // if repository was not found then create it, store its instance and return it
      if (this.connection.driver.options.type === "mongodb") {
        var newRepository = new MongoRepository(target, this, this.queryRunner);
        this.repositories.push(newRepository);
        return newRepository;
      } else {
        var _newRepository = new Repository(target, this, this.queryRunner);
        this.repositories.push(_newRepository);
        return _newRepository;
      }
    }
    /**
     * Gets tree repository for the given entity class or name.
     * If single database connection mode is used, then repository is obtained from the
     * repository aggregator, where each repository is individually created for this entity manager.
     * When single database connection is not used, repository is being obtained from the connection.
     */
  }, {
    key: "getTreeRepository",
    value: function getTreeRepository(target) {
      // tree tables aren't supported by some drivers (mongodb)
      if (this.connection.driver.treeSupport === false) throw new TreeRepositoryNotSupportedError(this.connection.driver);
      // find already created repository instance and return it if found
      var repository = this.treeRepositories.find(function (repository) {
        return repository.target === target;
      });
      if (repository) return repository;
      // check if repository is real tree repository
      var newRepository = new TreeRepository(target, this, this.queryRunner);
      this.treeRepositories.push(newRepository);
      return newRepository;
    }
    /**
     * Gets mongodb repository for the given entity class.
     */
  }, {
    key: "getMongoRepository",
    value: function getMongoRepository(target) {
      return this.connection.getMongoRepository(target);
    }
    /**
     * Creates a new repository instance out of a given Repository and
     * sets current EntityManager instance to it. Used to work with custom repositories
     * in transactions.
     */
  }, {
    key: "withRepository",
    value: function withRepository(repository) {
      var repositoryConstructor = repository.constructor;
      var target = repository.target,
        manager = repository.manager,
        queryRunner = repository.queryRunner,
        otherRepositoryProperties = _objectWithoutProperties(repository, _excluded);
      return Object.assign(new repositoryConstructor(repository.target, this), _objectSpread({}, otherRepositoryProperties));
    }
    /**
     * Gets custom entity repository marked with @EntityRepository decorator.
     *
     * @deprecated use Repository.extend to create custom repositories
     */
  }, {
    key: "getCustomRepository",
    value: function getCustomRepository(customRepository) {
      var entityRepositoryMetadataArgs = getMetadataArgsStorage().entityRepositories.find(function (repository) {
        return repository.target === (typeof customRepository === "function" ? customRepository : customRepository.constructor);
      });
      if (!entityRepositoryMetadataArgs) throw new CustomRepositoryNotFoundError(customRepository);
      var entityMetadata = entityRepositoryMetadataArgs.entity ? this.connection.getMetadata(entityRepositoryMetadataArgs.entity) : undefined;
      var entityRepositoryInstance = new entityRepositoryMetadataArgs.target(this, entityMetadata);
      // NOTE: dynamic access to protected properties. We need this to prevent unwanted properties in those classes to be exposed,
      // however we need these properties for internal work of the class
      if (entityRepositoryInstance instanceof AbstractRepository) {
        if (!entityRepositoryInstance["manager"]) entityRepositoryInstance["manager"] = this;
      } else {
        if (!entityMetadata) throw new CustomRepositoryCannotInheritRepositoryError(customRepository);
        entityRepositoryInstance["manager"] = this;
        entityRepositoryInstance["metadata"] = entityMetadata;
      }
      return entityRepositoryInstance;
    }
    /**
     * Releases all resources used by entity manager.
     * This is used when entity manager is created with a single query runner,
     * and this single query runner needs to be released after job with entity manager is done.
     */
  }, {
    key: "release",
    value: function () {
      var _release = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee17() {
        return _regeneratorRuntime().wrap(function _callee17$(_context17) {
          while (1) switch (_context17.prev = _context17.next) {
            case 0:
              if (this.queryRunner) {
                _context17.next = 2;
                break;
              }
              throw new NoNeedToReleaseEntityManagerError();
            case 2:
              return _context17.abrupt("return", this.queryRunner.release());
            case 3:
            case "end":
              return _context17.stop();
          }
        }, _callee17, this);
      }));
      function release() {
        return _release.apply(this, arguments);
      }
      return release;
    }()
  }]);
  return EntityManager;
}();